import { useState, useEffect, useContext,useRef } from "react";
import { petitions } from "../../../../api/calls";
import { DataContext } from "../../../../context/DataContext";
import { toast } from "sonner";
import Table from "../../../componentsTable/Table";
import TableLoad from "../../../componentsTools/TableLoad";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { exportToExcel_v1 } from "../../../componentsTools/ExportToExcel";
import { useForm } from "react-hook-form";

export default function VerCotizacion() {
  const { session, idEmpresa } = useContext(DataContext);
  const [fechas, setFechas] = useState({ fInicio: "", fFin: "" });
  const [filtering, setFiltering] = useState("");
  const [cotizaciones, setCotizaciones] = useState([]);
  const [load, setLoad] = useState(true);

  const modalEmail = useRef(null);
  const modalWsp = useRef(null);

  const navigate = useNavigate();
  
  const form1 = useForm({
    defaultValues: {
      idVenta: "",
      email: "",
    },
  });

  const form2 = useForm({
    defaultValues: {
      idVenta: "",
      numero: "",
      indice: "51",
    },
  });

  const columns = [
    {
      header: "Fecha",
      accessorKey: "fecRegistro",
      cell: ({ row }) => (
        <td className="last-order align-middle white-space-nowrap text-body-tertiary">
          {row.original.fecRegistro}
        </td>
      ),
    },
    {
      header: "Comprobante",
      accessorFn: (row) =>
        `${row.tipComprobante}-${row.serComprobante}-${row.nroComprobante}`,
      cell: ({ row }) => (
        <td className="product align-middle ps-1 text-start">
          <span className="badge text-bg-info fs-9 rounded-4">
            <span className="badge-label">
              {" "}
              {row.original.tipComprobante}-{row.original.serComprobante}-{" "}
              {row.original.nroComprobante}
            </span>
          </span>
        </td>
      ),
    },
    {
      header: "Cliente",
      accessorKey: "razon",
      cell: ({ row }) => (
        <td className="product align-middle ps-2">{row.original.razon}</td>
      ),
    },
    {
      header: "Moneda",
      accessorKey: "moneda",
      cell: ({ row }) => (
        <td className="product align-middle ps-4 fw-bold">
          {row.original.moneda}
        </td>
      ),
    },
    {
      header: "Importe total",
      accessorKey: "impTotal",
      cell: ({ row }) => (
        <td className="price align-middle white-space-nowrap text-start fw-bold text-body-tertiary ps-4">
          {row.original.impTotal.toFixed(2)}
        </td>
      ),
    },
    {
      header: "Expiración",
      accessorKey: "fecVencimiento",
      cell: ({ row }) => (
        <td className="last-order align-middle white-space-nowrap text-body-tertiary">
          {row.original.fecOperacion.split(" ")[0]}
        </td>
      ),
    },
    {
      header: "Usuario",
      accessorKey: "nombre",
      cell: ({ row }) => (
        <td className="last-order align-middle white-space-nowrap text-body-tertiary fw-bold">
          {row.original.nombre}
        </td>
      ),
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      cell: ({ row }) => (
        <td className="product align-middle ps-4">
          <div className="btn-reveal-trigger position-static">
            <button
              className="btn btn-sm dropdown-toggle dropdown-caret-none transition-none btn-reveal fs-10"
              type="button"
              data-bs-toggle="dropdown"
              data-boundary="window"
              aria-haspopup="true"
              aria-expanded="false"
              data-bs-reference="parent"
              disabled={row.original.anulado === "S"}
              onClick={(e) => e.stopPropagation()}
            >
              <span className="fas fa-ellipsis-h fs-10"></span>
            </button>
            <div className="dropdown-menu dropdown-menu-end py-2" onClick={(e) => e.stopPropagation()}>
              <button className="dropdown-item" onClick={() => printCotizacion(row.original)}>
                <span className="fa-solid fas fa-print text-body-secondary me-2"></span>
                <span className="text-body-secondary">Imprimir</span>
              </button>
              <button className="dropdown-item" onClick={() => abrirModalEmail(row.original)}>
                <span className="fa-solid fas fa-envelope text-body-secondary me-2"></span>
                <span className="text-body-secondary">Enviar por email</span>
              </button>
              <button
                className="dropdown-item"
                onClick={() => abrirModalWsp(row.original)}
              >
                <span className="fa-solid fab fa-whatsapp text-body-secondary me-2"></span>
                <span className="text-body-secondary">Enviar por WhatsApp</span>
              </button>
              <button className="dropdown-item" onClick={() => getReportCotizacion(row.original)}>
                <span className="fa-solid fas fa-file-pdf text-body-secondary me-2"></span>
                <span className="text-body-secondary">Descargar PDF</span>
              </button>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item text-info" onClick={() => {handleRowClick(row.original)}}>
                <span>Editar</span>
              </button>
              <button
                className="dropdown-item text-danger"
                onClick={() => {
                  deleteCotizacion(row.original);
                }}
              >
                <span>Anular</span>
              </button>
            </div>
          </div>
        </td>
      ),
    },
  ];

  const abrirModalWsp = async (row) => {
    form2.reset();
    form2.setValue("idVenta", row.idVenta);
    const modal = new window.bootstrap.Modal(modalWsp.current);
    modal.show();
  }

  const abrirModalEmail = (row) => {
    form1.reset();
    form1.setValue("idVenta", row.idVenta);
    const modal = new window.bootstrap.Modal(modalEmail.current); 
    modal.show();
  };

  const getReportCotizacion = async (row) => {
    const download = (response) => {
      if (response.isError) {
        toast.error(response.data || "No se pudo obtener el reporte");
        return;
      }

      const blob = new Blob([response.blob], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${row.tipComprobante}-${row.serComprobante}-${row.nroComprobante}.pdf`;
      a.click();
      URL.revokeObjectURL(url);
    };

    toast("¿En qué formato deseas exportar la cotización?", {
      action: {
        label: "Ticket",
        onClick: async () => {
          try {
            const response = await petitions.getReportTicket(
              idEmpresa(),
              session().token,
              row?.idVenta
            );
            download(response);
          } catch {
            toast.error("Error al obtener la cotización en Ticket");
          }
        },
      },
      cancel: {
        label: "A4",
        onClick: async () => {
          try {
            const response = await petitions.getReportCotizacion(
              idEmpresa(),
              session().token,
              row?.idVenta
            );
            download(response);
          } catch {
            toast.error("Error al obtener la cotización en A4");
          }
        },
      },
    });
  };

  // Imprimir cotización
  const printCotizacion = async (row) => {
    const printPdf = (response) => {
      if (response.isError) {
        toast.error(response.message || "No se pudo obtener el reporte");
        return;
      }

      const fileURL = window.URL.createObjectURL(response.blob);

      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = fileURL;

      document.body.appendChild(iframe);

      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      };
    };

    toast("¿En qué formato deseas imprimir la cotización?", {
      action: {
        label: "Ticket",
        onClick: async () => {
          try {
            const response = await petitions.getReportTicket(
              idEmpresa(),
              session().token,
              row?.idVenta
            );
            printPdf(response);
          } catch {
            toast.error("Error al imprimir la cotización en Ticket");
          }
        },
      },
      cancel: {
        label: "A4",
        onClick: async () => {
          try {
            const response = await petitions.getReportCotizacion(
              idEmpresa(),
              session().token,
              row?.idVenta
            );
            printPdf(response);
          } catch {
            toast.error("Error al imprimir la cotización en A4");
          }
        },
      },
    });
  };



  const deleteCotizacion = (row) => {
    toast(
      "¿Estas seguro/a de anular esta cotización " +
        row?.tipComprobante +
        "-" +
        row?.serComprobante +
        "-" +
        row?.nroComprobante +
        "?",
      {
        action: {
          label: "Si, anular",
          onClick: async () => {
            const response = await petitions.anularVenta(
              idEmpresa(),
              session().token,
              { idVenta: row?.idVenta }
            );
            if (response.status === "success") {
              toast.success(
                "Cotización " +
                  row?.tipComprobante +
                  "-" +
                  row?.serComprobante +
                  "-" +
                  row?.nroComprobante +
                  " anulada correctamente"
              );
            } else {
              const msg =
                typeof response.code === "string"
                  ? response.message
                  : response.data;
              toast.error(msg);
            }
          },
        },
      }
    );
  };

  const handleRowClick = (row) => {
    navigate("/main/editprice", {
      replace: true,
      state: { idCotizacion: row.idVenta, main: "/main/VerCotizacion" },
    });
  };

  useEffect(() => {
    const today = new Date();
    const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const formatDate = (date) => date.toISOString().split("T")[0];

    const fechasIniciales = {
      fInicio: formatDate(firstDay),
      fFin: formatDate(lastDay),
    };

    setFechas(fechasIniciales);
    LoadCotizaciones(fechasIniciales);
  }, []);

  const LoadCotizaciones = async ({ fInicio, fFin }) => {
    if (!fInicio || !fFin) return;
    setLoad(true);
    const response = await petitions.getCotizaciones(
      idEmpresa(),
      session().token,
      fInicio,
      fFin
    );

    if (response.status === "success") {
      setCotizaciones(response.data);
      setLoad(false);
    } else {
      const msg =
        typeof response.code === "string" ? response.message : response.data;
      toast.error(msg);
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setFechas((prevFechas) => ({
      ...prevFechas,
      [name]: value,
    }));
  };

  const sendEmail = form1.handleSubmit(async (data) => {
      const promise = petitions.sendEmailVenta(
        idEmpresa(),
        session().token,
        data.idVenta,
        data.email
      );
  
      toast.promise(promise, {
        loading: 'Enviando email...',
        success: (response) => {
          if (response.status === "success") {
            const modalInstance = window.bootstrap.Modal.getInstance(modalEmail.current);
            modalInstance.hide();
            return "Email enviado correctamente";
          } else {
            throw new Error(response.message || response.data || "Error desconocido");
          }
        },
        error: (err) => {
          if (err?.status === "error") {
            return err.message || err.data || "Error al enviar el email";
          }
          return "Error... :( Intenta de nuevo!";
        }
      });
    });

  const sendWsp = form2.handleSubmit(async (data) => {
    const response = await petitions.getReportCotizacion(
      idEmpresa(),
      session().token,
      data?.idVenta
    );

    if (response.isError) {
      toast.error(response.message || "No se pudo obtener el reporte");
      return;
    }

    const fileURL = window.URL.createObjectURL(response.blob);

    var url = `https://wa.me/${data.indice}${data.numero}?text=${"Buenas tardes, adjunto el comprobante electronico: " + fileURL}`;
    window.open(url, '_blank'); 

    const modalInstance = window.bootstrap.Modal.getInstance(modalWsp.current);
    modalInstance.hide();
    toast.success("Mensaje enviado por WhatsApp");
  })

  return (
    <>
      <div className="mb-9">
        <div className="row g-3 mb-2">
          <div className="col-auto">
            <h2 className="mb-0">Cotizaciones</h2>
          </div>
        </div>
        <ul className="nav nav-links mb-3 mb-lg-2 mx-n3">
          <li className="nav-item">
            <div className="nav-link disabled" aria-current="page">
              <span className="text-secondary">Todos </span>
              <span className="text-body-tertiary fw-semibold">
                ({cotizaciones.length})
              </span>
            </div>
          </li>
          <li className="nav-item">
            <div className="nav-link disabled" aria-current="page">
              <span className="text-success">Operativos </span>
              <span className="text-body-tertiary fw-semibold">
                ({cotizaciones?.filter((v) => v.anulado === "N").length})
              </span>
            </div>
          </li>
          <li className="nav-item">
            <div className="nav-link disabled" aria-current="page">
              <span className="text-danger">Anulados </span>
              <span className="text-body-tertiary fw-semibold">
                <span className="text-body-tertiary fw-semibold">
                ({cotizaciones?.filter((v) => v.anulado === "S").length})
              </span>
              </span>
            </div>
          </li>
        </ul>
        <div className="mb-4">
          <div className="row g-1">
            <div className="col-auto">
              <div className="search-box">
                <form className="position-relative">
                  <input
                    className="form-control search-input search rounded-4 border-0 shadow-sm"
                    type="search"
                    placeholder="Buscar cotizaciones"
                    aria-label="Search"
                    value={filtering}
                    onChange={(e) => setFiltering(e.target.value)}
                  />
                  <span className="fas fa-search search-box-icon"></span>
                </form>
              </div>
            </div>
            <div className="col-auto scrollbar overflow-hidden-y flex-grow-3 mb-2">
              <div className="btn-group position-static" role="group">
                <div className="d-flex align-items-center gap-3">
                  <label className="form-label" htmlFor="datepickerDesde">
                    Desde
                  </label>
                  <input
                    className="form-control rounded-4 border-0 shadow-sm"
                    id="datepickerDesde"
                    type="date"
                    name="fInicio"
                    value={fechas.fInicio}
                    onChange={handleDateChange}
                  />

                  <label className="form-label" htmlFor="datepickerHasta">
                    Hasta
                  </label>
                  <input
                    className="form-control rounded-4 border-0 shadow-sm"
                    id="datepickerHasta"
                    type="date"
                    name="fFin"
                    value={fechas.fFin}
                    onChange={handleDateChange}
                  />

                  <button
                    className="btn px-3 btn-phoenix-secondary rounded-4"
                    type="button"
                    onClick={() => {
                      LoadCotizaciones(fechas);
                    }}
                  >
                    <span
                      className="fa-solid fa-filter text-primary"
                      data-fa-transform="down-3"
                    ></span>
                  </button>

                  <div className="me-2">
                    <button
                      className="btn px-3 btn-phoenix-secondary rounded-4"
                      type="button"
                      data-bs-toggle="dropdown"
                      data-boundary="window"
                      aria-haspopup="true"
                      aria-expanded="false"
                      data-bs-reference="parent"
                      disabled={true}
                    >
                      <span className="fa-solid fa-ellipsis"></span>
                    </button>
                    <ul
                      className="dropdown-menu dropdown-menu-end p-0"
                      style={{ zIndex: 9999 }}
                    >
                      <li>
                        <a className="dropdown-item" href="#!">
                          View profile
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#!">
                          Report
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item" href="#!">
                          Manage notifications
                        </a>
                      </li>
                      <li>
                        <a className="dropdown-item text-danger" href="#!">
                          Delete Lead
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-auto">
              <button
                className="btn btn-link text-body me-4 px-0"
                onClick={() =>
                  exportToExcel_v1(cotizaciones, columns, "Cotizaciones")
                }
              >
                <span className="fa-solid fa-file-export fs-9 me-2"></span>
                Exportar
              </button>
              <NavLink
                className="btn btn-primary rounded-4"
                to={"/main/EmitirCotizacion"}
              >
                <span className="fas fa-plus me-2"></span>Agregar cotización
              </NavLink>
            </div>
          </div>
        </div>
        <div className="mx-n4 px-4 mx-lg-n6 px-lg-6 bg-body-emphasis border-top border-bottom border-translucent position-relative top-1">
          <div className="table-table-responsive scrollbar mx-n1 px-1">
            {load ? (
              <TableLoad />
            ) : (
              <Table
                data={cotizaciones}
                columns={columns}
                filtering={filtering}
                setFiltering={setFiltering}
                handleRowClick={handleRowClick}
                classNameTable={"table fs-9 mb-0 table-hover"}
              />
            )}
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-hidden="true"
        ref={modalEmail}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-4">
            <form onSubmit={sendEmail}>
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Enviar por correo electronico
                </h5>
                <button
                  className="btn p-1"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span className="fas fa-times fs-9"></span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="input-group mb-1">
                      <span className="input-group-text" id="basic-addon1">
                        @
                      </span>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Email"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        {...form1.register("email", {
                          required: "El email es requerido",
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Email no válido",
                          },
                        })}
                      />
                    </div>
                    {form1.formState.errors.email && (
                      <span className="text-danger">
                        {form1.formState.errors.email.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Enviar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-hidden="true"
        ref={modalWsp}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-4">
            <form onSubmit={sendWsp}>
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Enviar por WhatsApp
                </h5>
                <button
                  className="btn p-1"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span className="fas fa-times fs-9"></span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="input-group mb-1">
                      <span className="input-group-text" id="basic-addon1">
                        +
                      </span>
                      <input
                        className="form-control"
                        type="number"
                        placeholder="51"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        {...form2.register("indice", {
                          required: "El número es requerido",
                        })}
                      /> 
                    </div>
                    {form2.formState.errors.indice && (
                      <span className="text-danger">
                        {form2.formState.errors.indice.message}
                      </span>
                    )}
                  </div>
                  <div className="col-lg-8">
                    <div className="input-group mb-1">
                      <input
                        className="form-control"
                        type="number"
                        placeholder="999 999 999"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        {...form2.register("numero", {
                          required: "El número es requerido",
                          pattern: {
                            value: /^\+?[1-9]\d{1,14}$/,
                            message: "Número no válido",
                          },
                        })}
                      /> 
                    </div>
                    {form2.formState.errors.numero && (
                      <span className="text-danger">
                        {form2.formState.errors.numero.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Enviar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
